import { TOGGLE_OVERLAY } from './ActionTypes';

export default function toggles(state = {}, action) {
    switch (action.type) {
        case TOGGLE_OVERLAY:
            return {
                ...state,
                [action.key]: action.force !== undefined ? action.force : !state[action.key],
            };
        default:
            return state;
    }
}
